export const SET_ARRAY = 'SET_ARRAY';
export const SET_ARRAY_SIZE = 'SET_ARRAY_SIZE';
export const SET_SORTING_SPEED = 'SET_SORTING_SPEED';
